const AUTH_HEADERS: string[] = ['Authorization'];

// The JWT is mirrored into a cookie scoped to /edu so the course iframes' own requests
// (scripts, runtime-data.js, videos) carry it; the backend gates those files on it.
const EDU_COOKIE_PATH = '/edu';
const EDU_COOKIE_MAX_AGE = 24 * 60 * 60;

interface Data {
  [x: string]: string;
}

function setEduCookie(authorization: string): void {
  const token = authorization.replace(/^Bearer\s+/i, '');
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `Authorization=${token}; Path=${EDU_COOKIE_PATH}; Max-Age=${EDU_COOKIE_MAX_AGE}; SameSite=Lax${secure}`;
}

function clearEduCookie(): void {
  document.cookie = `Authorization=; Path=${EDU_COOKIE_PATH}; Max-Age=0; SameSite=Lax`;
}

export function setAuthData(data: Data): void {
  if (data) {
    AUTH_HEADERS.forEach((key) => {
      localStorage[key] = data[key];
    });
    if (data.Authorization) setEduCookie(data.Authorization);
  }
}

export function getAuthData() {
  const data: Data = {};
  AUTH_HEADERS.forEach((key) => {
    data[key] = localStorage[key];
  });
  return data;
}

export function clearAuthData() {
  console.warn('%c clearAuthData()', 'color: blue');

  [...AUTH_HEADERS].forEach((key) => delete localStorage[key]);
  clearEduCookie();
}
